module.exports = "/virtual-football-league/img/amblems/left/logos/Fake_CrystalPalace.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Fake_CrystalPalace.png
// module id = 2081
// module chunks = 4